import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { COMMON_ANCHOR_ID_SCROLL_TO } from '@yme/utils/constants';
import { HeroSection } from './HeroSection';
import { isHeroSectionEmpty } from './helpers';
const heroSectionEditConfig = {
    emptyLabel: 'Hero Section',
    isEmpty: isHeroSectionEmpty,
};
export default MapTo([
    AEM_FUNCTIONS.clpHeroSection,
    AEM_FUNCTIONS.slpHeroSection,
])((props) => HeroSection({
    scrollToComponentId: COMMON_ANCHOR_ID_SCROLL_TO,
    ...props,
}), heroSectionEditConfig);
